/*
  Size guide modal: delegated handlers.
  Replaces the inline DOMContentLoaded handlers in sections/custom__product-size-chart.liquid,
  which only bound to elements present at page load (so triggers inside quick view never worked)
  and did nothing on templates that don't include the size chart section.
*/
(function () {
  if (window.__nsSizeGuide) return;
  window.__nsSizeGuide = true;

  var OPEN_CLASS = 'sizechart-open';
  var lastTrigger = null;

  function section() {
    return document.querySelector('.shopify-section.product-size-chart-section');
  }

  function open(trigger) {
    var s = section();
    if (!s) {
      // No modal on this template (quick view, landing, with-tabs, gift card): use the size guide page.
      var url = trigger && trigger.getAttribute('data-fallback-url');
      if (url) window.open(url, '_blank', 'noopener');
      return;
    }
    lastTrigger = trigger;
    s.classList.add(OPEN_CLASS);
    var close = s.querySelector('.size-chart-close');
    if (close) {
      if (!close.hasAttribute('tabindex')) close.setAttribute('tabindex', '0');
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', 'Close size guide');
      close.focus({ preventScroll: true });
    }
  }

  function close() {
    var s = section();
    if (!s || !s.classList.contains(OPEN_CLASS)) return;
    s.classList.remove(OPEN_CLASS);
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-size-guide-trigger], .product-size-chart___icon.product__information-popup');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }
    if (e.target.closest('.product-size-chart-wrap .size-chart-close, .product-size-chart__overlay')) {
      close();
      return;
    }
    var tab = e.target.closest('.size-chart-tabs .size-chart-tab');
    if (tab) {
      var wrap = tab.closest('.product-size-chart-wrap');
      if (!wrap) return;
      wrap.querySelectorAll('.size-chart-tab').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      wrap.querySelectorAll('.size-chart-content').forEach(function (panel) {
        panel.hidden = panel.id !== tab.dataset.target;
      });
      var pop = wrap.querySelector('.product-size-chart.popover');
      if (pop) pop.scrollTop = 0;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.size-chart-close')) {
      e.preventDefault();
      close();
    }
  });
})();
